'use strict';

var _classCallCheck = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var codeContext = require('parse-code-context');
/**
 * Get the code context for the given comment.
 *
 * @param {String} `str` string of JavaScript
 * @param {Object} `comment` Block comment instance
 */


var Context = function Context(str, comment, nextComment, options) {
  _classCallCheck(this, Context);

  this.context = {};
  this.value = '';
  this.range = [comment.codeStart || 0];

  if (options.context === false) {
    return;
  }
  /**
   * Loop until we get to a non-whitespace, non-newline character
   * If codeContext returns a parsed object, it's used as context,
   * otherwise we assume that no code follows the comment.
   */


  var begin = comment.range[1];
  var end = nextComment ? nextComment.range[0] : str.length;
  var after = str.slice(begin, end);
  var lineno = comment.loc.end.line;
  ;
  var col = 0;

  if (after[0] === '\n') {
    after = after.slice(1);
  } else {
    col = comment.loc.end.column;
  }

  var lines = after.split('\n');
  var rangeStart = begin;
  var rangeEnd = begin;
  var append = 0;

  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    append += 1;
    lineno++;

    if (line && !/^\s+/.test(line)) {
      this.context = codeContext(line);
      this.value = line;
      break;
    }

    append += line.length;
  }
  /**
   * Create location object
   */


  rangeStart += append;
  rangeEnd += append + this.value.length;
  this.range = [rangeStart, rangeEnd];
  this.loc = {
    start: {
      line: lineno,
      column: col
    },
    end: {
      line: lineno,
      column: col + this.value.length
    }
  };
};
/**
 * Expose `Context`
 */


module.exports = Context;